module.exports = __webpack_public_path__ + "img/center-intro-structure5-1.f13fd01a.png";